import React from 'react';

/**
 * StatBlock (#673) — a reusable, copyable numeric block.
 *
 * Renders a titled group of label/value metrics using the existing 10yr
 * To-Date stat-block classes (`stats-todate-metric` etc.) as the style guide,
 * so the numbers behind every stats chart are shown as plain text that can be
 * read and copied (charts alone are not copyable).
 *
 * Values are rendered as-is: pass integers for counts and pre-formatted
 * strings (e.g. hectares with thousands separators) where formatting matters.
 */
export interface StatItem {
    label: string;
    value: string | number;
}

interface StatBlockProps {
    title?: string;
    items: StatItem[];
}

const StatBlock: React.FC<StatBlockProps> = ({ title, items }) => (
    <div className="stats-block">
        {title && <div className="stats-block__title">{title}</div>}
        <div className="stats-todate-headline">
            {items.map(item => (
                <div className="stats-todate-metric" key={item.label}>
                    <span className="stats-todate-metric__label">{item.label}</span>
                    <span className="stats-todate-metric__value">{item.value}</span>
                </div>
            ))}
        </div>
    </div>
);

export default StatBlock;
